import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import type { MaybeRefOrGetter } from '@tanstack/vue-query/build/legacy/types'
import type { GetProfileFeedQuery } from '~~/src/api/feed'
import { getProfileFeed } from '~~/src/api/feed'

export const useProfileFeed = (userId: string, args: GetProfileFeedQuery, options?: {
  enabled?: MaybeRefOrGetter<boolean>
}) => {
  const queryKey = args.elemental_type_id ? ['profile-list-elementals', args.elemental_type_id, ...Object.values(args)] : ['profile-list-elementals', 'all', ...Object.values(args)]
  return useQuery({
    queryKey,
    queryFn: async () => {
      return getProfileFeed(userId, args)
    },
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    enabled: computed(() => options?.enabled ?? false) as any,
  })
}
